
import {Grid} from "@mui/material";
import Tarjeta_Blog_Home from "../../Tarjetas/Tarjeta_Blog_Home";
import blogs from '../../../../data/post.json'

const Lista_Blog = () => {

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid container spacing={3} size={{xs: 12, sm: 12, md: 12}} sx={{pt: 8}}>
                {blogs.map((blog, index) => (
                    <Grid container size={{xs: 12, sm: 6, md: 6}} key={index}>
                        <Tarjeta_Blog_Home titulo={blog.titulo}
                                           descripcion={blog.descripcion}
                                           imagen={blog.imagen}
                                           autor={blog.autor}
                                           fechaPublicacion={blog.fechaPublicacion}
                                           id={blog.id}/>
                    </Grid>
                ))}
            </Grid>
        </Grid>
    )

}
export default Lista_Blog